import globalStore from '@/services/global.state';
import {getUrlParams} from '@components/utils';
import type {OpenDiskPayType} from '@fe-progressive/package-progressive/recharge';

/** 外部 payType：路由或 URL 查询，与 useType 一致时可用 1=UPI、2=CRYPTO（与 indusbet-main recharge.tsx 一致） */
export function parseExternalPayType(
  raw: unknown,
): OpenDiskPayType | undefined {
  if (raw == null || raw === '') {
    return undefined;
  }
  const s = String(raw).trim().toUpperCase();
  if (s === 'UPI' || s === '1') {
    return 'UPI';
  }
  if (s === 'CRYPTO' || s === '2') {
    return 'CRYPTO';
  }
  return undefined;
}

export function readExternalPayTypeRaw(routeParams: unknown): unknown {
  const fromRoute = (routeParams as {payType?: string | number} | undefined)
    ?.payType;
  if (fromRoute != null && fromRoute !== '') {
    return fromRoute;
  }
  if (globalStore.isWeb) {
    return getUrlParams().payType;
  }
  return undefined;
}

/** 解析 route / Web query 中的 payType，无有效值时默认 UPI */
export function resolveOpenDiskPayTypeFromRoute(
  routeParams: unknown,
): OpenDiskPayType {
  return parseExternalPayType(readExternalPayTypeRaw(routeParams)) ?? 'UPI';
}
